





































































import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { copyToClipboard } from '@/helpers/dom';

import Disclaimer from '@/shared/components/Disclaimer/Disclaimer.vue';

@Component({
  components: {
    Disclaimer,
  }
})
export default class CreditCardPixPaymentFeedback extends Vue {
  @Prop()
  private readonly statusPayment!: string;

  @Prop()
  private readonly isRenew!: boolean;

  @Prop()
  private readonly instructions!: any;

  private copyTextMessage: string = 'Texto copiado com sucesso!';

  private showCopyFeedback: boolean = false;

  private get isStatusWaitingPayment() {
    return this.statusPayment === 'waiting-for-payment';
  }

  private get title() {
    return this.isStatusWaitingPayment && this.$t('App.Checkout.creditCardPix.waitingPayment.title');
  }

  private get subtitle() {
    return this.isStatusWaitingPayment
      && this.instructions
      && this.$t('App.Checkout.creditCardPix.waitingPayment.subtitle', [this.isRenew ? 'contrato' : 'pedido', this.instructions.id, this.instructions.offer_name]);
  }

  private get description() {
    return this.isStatusWaitingPayment && this.$t('App.Checkout.creditCardPix.waitingPayment.description');
  }

  private get pixCode () {
    return this.instructions.pix_code;
  }

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private copyValueToClipboard (value: any): void {
    this.copyTextMessage = 'Código Pix copiado';

    copyToClipboard(value);

    this.showCopyFeedback = true;
  }
}
